var map = {
	"./ds-message-icon-error.svg": 87360,
	"./ds-message-icon-info.svg": 87074,
	"./ds-message-icon-question.svg": 25250,
	"./ds-message-icon-success.svg": 72379,
	"./ds-message-icon-warning.svg": 89158,
	"./icon-404.svg": 68408,
	"./icon-failure-retry.svg": 87491,
	"./icon-survey-finished.svg": 8037,
	"./logo.svg": 9753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84951;